import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center px-6">
      <div data-testid="payment-cancel" className="bg-white rounded-3xl p-10 max-w-md w-full text-center border border-brand-green/15 shadow-xl">
        <XCircle size={64} className="mx-auto text-red-400" />
        <h1 className="font-heading text-4xl text-brand-dark uppercase mt-6">{t("payment.cancelTitle")}</h1>
        <p className="text-sm text-brand-brown mt-3">{t("payment.cancelDesc")}</p>
        <div className="mt-8 flex gap-3 justify-center">
          <button data-testid="payment-retry-button" onClick={() => navigate("/checkout")}
            className="px-6 py-3 rounded-full bg-brand-orange text-white font-bold text-sm uppercase hover:bg-brand-dark transition-colors">
            {t("payment.retry")}
          </button>
          <button data-testid="payment-cancel-home" onClick={() => navigate("/")}
            className="px-6 py-3 rounded-full border-2 border-brand-dark text-brand-dark font-bold text-sm uppercase hover:bg-brand-yellow transition-colors">
            {t("payment.home")}
          </button>
        </div>
      </div>
    </div>
  );
}
